import { notifications } from "@mantine/notifications";
import React, { useState } from "react";
import { GET_COMPANY_INTEGRATION, SET_COMPANY_INTEGRATION } from "../../services/companies";
import InputField, { InputFieldTypes } from "../input_field";
import { Avatar, Box, Button, Grid, Group, Loader, Paper, Stack, Text, Title, useMantineTheme } from "@mantine/core";
import { CONNECT_RETELL, GET_ALL_RETELLS } from "../../services/retells";

export default function Retell() {
    const [items, setItems] = useState<any[]>([]);
    const [data, setData] = useState<any>(null);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [updated, setUpdated] = useState<boolean>(false);
    const [loadingItems, setLoadingItems] = useState<boolean>(false);

    const theme = useMantineTheme();

    const handleChange = (dt: any) => setData((u: any) => ({ ...u, ...dt }))

    const loadData = () => {
        setLoadingItems(true)
        GET_ALL_RETELLS()
            .then((res) => {
                setItems(res)
                setUpdated(false);
                setTimeout(() => { setUpdated(false) }, 800);
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
            .finally(() => {
                setLoadingItems(false)
            })
    }

    const handleSave = () => {
        setLoadingSave(true)
        CONNECT_RETELL({ ...data, default: true })
            .then((res) => {
                loadData();
                setUpdated(false);
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
            .finally(() => {
                setLoadingSave(false)
            })
    }

    React.useEffect(() => { loadData() }, [])
    React.useEffect(() => { setUpdated(true) }, [data])

    return <Stack>
        <Group>
            <Avatar size={40} src="/assets/retell.png" />
            <Title c="gray.0" order={5}>Retell</Title>
        </Group>
        <Stack>
            <Group align="flex-end">
                <Box style={{ flex: 1 }}>
                    <InputField
                        name="key"
                        value={items[0]?.credentials?.key ?? data?.key}
                        readOnly={items.length > 0}
                        fieldType={InputFieldTypes.PASSWORD}
                        onChange={handleChange}
                        title="API Key"
                        placeholder="Paste your API KEY"
                    />
                </Box>
                {items.length === 0 && <Button
                    disabled={
                        ((data?.key ?? "").length < 10) || !updated
                    }
                    size="md"
                    onClick={handleSave}
                    loading={loadingSave || loadingItems}
                    color="green"
                >Connect</Button>}
            </Group>
        </Stack>
    </Stack>
}
